import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ITicketUserDetailsResponse } from './get-ticket-user-details-response';
import { ticketUserDetailsResponseSchema } from './get-ticket-user-details-response';

export async function getTicketUserDetailsApi(
  ticketId: number,
): Promise<IValidatedResponse<ITicketUserDetailsResponse>> {
  return getRequest<ITicketUserDetailsResponse>({
    path: `/sys/ticket/${ticketId}/user-details`,
    schema: ticketUserDetailsResponseSchema,
  });
}
